// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import mixinUser from './mixins/user'
// import VeeValidate, {Validator } from 'vee-validate'
// import messages from 'vee-validate/dist/locale/zh_CN'
// Merge the locales.
// import validator from 'validator'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// const emailPhoneRule = {
//   getMessage (field, params, data) {
//     return (data && data.message) || '手机/邮箱 格式错误'
//   },
//   validate (value) {
//     return validator.isEmail(value) || validator.isMobilePhone(value, 'zh-CN')
//   }
// }
//
// const phoneRule = {
//   getMessage (field, params, data) {
//     return (data && data.message) || '手机格式错误'
//   },
//   validate (value) {
//     return validator.isMobilePhone(value, 'zh-CN')
//   }
// }
//
// VeeValidate.Validator.localize('zh-CN', messages)
// Validator.extend('emailPhone', emailPhoneRule)
// Validator.extend('phoneRule', phoneRule)
// Vue.use(VeeValidate, {
//   locale: 'zh_CN'
// })
Vue.prototype.$imgParse = (url) => {
  if (url.includes('http') || url.includes('https')) {
    return url
  } else {
    let location = '/app/'
    return `${location}${url}`
  }
}
Vue.mixin(mixinUser)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js